/**
 * Observer mixin
 *
 * Добавляет логику слежения за изменением пересечения элемента с областью видимости
 * Элемент должен содержать атрибут data-observe-id="${id}" и директиву v-observe="toggleObserver"
 * При попадании элемента в область видимости будет вызван метод onObserverEnter(id, el)
 *
 */

const OBSERVER = Object.freeze({
  APPEND: 'observe',
  REMOVE: 'unobserve',
});

export default {
  staticData: () => ({
    observer: null,
  }),
  created() {
    this.initObserver();
  },
  methods: {
    toggleObserver(el, action) {
      if (action === OBSERVER.REMOVE) {
        this.observer.unobserve(el);
      }
      if (action === OBSERVER.APPEND) {
        this.observer.observe(el);
      }
    },
    initObserver() {
      const options = { threshold: 0.99 };

      this.observer = new IntersectionObserver((entries) => {
        if (typeof this.onObserverEnter !== 'function') return;
        entries.forEach(({ intersectionRatio, target }) => {
          // В Chrome до 57 версии isIntersecting = undefined
          const { observeId } = target.dataset;
          if (intersectionRatio >= options.threshold && observeId) {
            this.onObserverEnter(observeId, target);
          }
        });
      }, options);

      this.$once('hook:beforeDestroy', () => {
        this.observer.disconnect();
      });
    },
  },
  directives: {
    observe: {
      inserted(el, binding) {
        binding.value(el, OBSERVER.APPEND);
      },
      unbind(el, binding) {
        binding.value(el, OBSERVER.REMOVE);
      },
    },
  },
};
